export default __webpack_public_path__ + "static/media/03-1.2cb5219d.png";